export default __webpack_public_path__ + "static/media/TeamCity.00917156.svg";